var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{grey: !_vm.code_flag,default:true},attrs:{"type":"button"},on:{"click":_vm.getPhoneCode}},[_vm._v(_vm._s(_vm.msg))])}
var staticRenderFns = []

export { render, staticRenderFns }